import Vue from 'vue'

export const baseUrl = Vue.config.devtools ? 'http://localhost:8000/' : window.location.origin + '/';